import { render, staticRenderFns } from "./DetailQuantityVoucherSoldOfStaffInAgent.vue?vue&type=template&id=24920526&scoped=true&"
import script from "./DetailQuantityVoucherSoldOfStaffInAgent.vue?vue&type=script&lang=js&"
export * from "./DetailQuantityVoucherSoldOfStaffInAgent.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuantityVoucherSoldOfStaffInAgent.vue?vue&type=style&index=0&id=24920526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24920526",
  null
  
)

export default component.exports